import type { PurchaseOrderItem, SupplierItem } from './types';

export const sampleSuppliers: SupplierItem[] = [
  {
    id: 'sup-1',
    name: 'Precision Microelectronics Corp',
    contact_name: 'David Miller',
    email: 'procurement@precisionmicro.com',
    phone: '+1-555-8291',
    lead_time_days: 7,
    min_order_qty: 20,
    rating: 4.8,
    status: 'ACTIVE',
  },
  {
    id: 'sup-2',
    name: 'Apex Semiconductor Fab',
    contact_name: 'Elena Rostova',
    email: 'orders@apexsemi.io',
    phone: '+1-555-4492',
    lead_time_days: 14,
    min_order_qty: 50,
    rating: 4.9,
    status: 'ACTIVE',
  },
];

export const samplePurchaseOrders: PurchaseOrderItem[] = [
  {
    id: 'po-1',
    po_number: 'PO-2026-0041',
    supplier_name: 'Precision Microelectronics Corp',
    status: 'SENT',
    order_date: new Date().toISOString(),
    expected_date: new Date(Date.now() + 5 * 86400000).toISOString(),
    total_amount: 4125.00,
  },
  {
    id: 'po-2',
    po_number: 'PO-2026-0042',
    supplier_name: 'Apex Semiconductor Fab',
    status: 'DRAFT',
    order_date: new Date().toISOString(),
    expected_date: new Date(Date.now() + 12 * 86400000).toISOString(),
    total_amount: 12500.00,
  },
];

export function adaptPurchaseOrder(raw: any): PurchaseOrderItem {
  if (!raw || typeof raw !== 'object') {
    return {
      id: Math.random().toString(),
      po_number: 'PO-UNKNOWN',
      supplier_name: 'Unknown Supplier',
      status: 'DRAFT',
      order_date: new Date().toISOString(),
      expected_date: '',
      total_amount: 0,
    };
  }
  return {
    id: String(raw.id || raw.po_number || Math.random()),
    po_number: String(raw.po_number || raw.number || 'PO-0000'),
    supplier_id: raw.supplier_id ? String(raw.supplier_id) : undefined,
    supplier_name: String(raw.supplier_name || raw.vendor_name || 'Unknown Supplier'),
    status: String(raw.status || 'DRAFT'),
    order_date: String(raw.order_date || raw.created_at || new Date().toISOString()),
    expected_date: String(raw.expected_date || raw.delivery_date || ''),
    total_amount: typeof raw.total_amount === 'number' ? raw.total_amount : (typeof raw.total === 'number' ? raw.total : 0),
    lines: Array.isArray(raw.lines) ? raw.lines : [],
  };
}

export function adaptSupplier(raw: any): SupplierItem {
  if (!raw || typeof raw !== 'object') {
    return {
      id: Math.random().toString(),
      name: 'Unknown Supplier',
      contact_name: '',
      email: '',
      phone: '',
      lead_time_days: 7,
      min_order_qty: 1,
      rating: 5.0,
      status: 'ACTIVE',
    };
  }
  return {
    id: String(raw.id || Math.random()),
    name: String(raw.name || 'Unnamed Supplier'),
    contact_name: String(raw.contact_name || raw.contact || ''),
    email: String(raw.email || ''),
    phone: String(raw.phone || ''),
    lead_time_days: Number(raw.lead_time_days ?? 7),
    min_order_qty: Number(raw.min_order_qty ?? 1),
    rating: Number(raw.rating ?? 5.0),
    status: String(raw.status || 'ACTIVE'),
  };
}
